import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { environment } from '../../environments/environment';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import * as _html2canvas from "html2canvas";
import * as XLSX from 'xlsx';
const html2canvas: any = _html2canvas;


@Component({
  selector: 'app-customer-details',
  templateUrl: './customer-details.component.html',
  styleUrls: ['./customer-details.component.css']
})
export class CustomerDetailsComponent implements OnInit {
  myOptions2: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
  };
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableSince: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate() - 6550  // disables dates from 18 years ago
    }
  };



  myOptions1: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
    // This will disable dates starting from tomorrow
  };


  states: string[] = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
    'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
    'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
    'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
    'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands',
    'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
    'Lakshadweep', 'Delhi', 'Puducherry'
  ];
  uploadDir: string = environment.uploadDir;
  @ViewChild('fileInput') fileInput;
  selectedOption: string;
  uploads_name: any = {};
  model: any;
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {
    cert_details: []
  };
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  savecertList: any;
  fieldName: string;
  fileList: FileList;
  certId: any;
  fileU: boolean;
  formedata: FormData;
  onlyview: boolean = false;
  options: any;
  getuintofmeasurement: any;
  formdata: FormData;
  upname: any;
  targetfile: any;
  Emp_Id: any;
  headerLabel: string;
  appSug: any = {};
  scheduler_id: any;
  emp_list: any;
  dataresult: any;
  date: Date;
  isExpanded: boolean = false;
  getAllCustomersList: any = [];
  EMPS: any = [];
  memberships: any = [];
  showMemAlert: boolean = false;
  show: boolean = false;
  defaultDate: string;
  memLastId: any;
  alreadyMember: any;
  module_access: any;
  addAccess: boolean = false;
  editAccess: boolean = false;
  viewAccess: boolean = false;
  deleteAccess: boolean = false;
  walletAccess: boolean = false;
  minDateTime: string;
  packages: any;
  removedPack: any = [];
  showUploadModal: boolean = false;
  selectedFile: File | null = null;
  uploadAccess: boolean;
  uploadErrors: any = [];
  how_do: any = [];
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService

  ) {
    this.uploads_name.inventory_manager_upload_path = {
      file_name: '',
      file_temp_name: '',
    };
    // this.defaultDate = "'" + (new Date().getFullYear() - 18) + "/01'";
    // alert(this.defaultDate)
    this.initVar();
    this.appSug = { lname: '' };

  }

  expandTextarea(event: Event): void {
    this.isExpanded = true;
  }

  collapseTextarea(event: Event): void {
    this.isExpanded = false;
  }

  checkModuleAcces(module_id: string, param): boolean {
    if (!this.module_access) {
      return false;
    }
    // Parse only if needed
    let accessArray = Array.isArray(this.module_access)
      ? this.module_access
      : JSON.parse(this.module_access);
    // Find that module
    const mod = accessArray.find(m => m.module_id == module_id);

    if (param) {
      if (mod) {
        return true; // module exists
      } else {
        return false;
      }
    } else {
      if (mod) {
        // Set individual access flags
        this.addAccess = !!mod.add;
        this.editAccess = !!mod.edit;
        this.viewAccess = !!mod.view;
        this.deleteAccess = !!mod.delete;
        this.walletAccess = !!mod.wallet;
        this.uploadAccess = !!mod.upload;
        return true; // module exists
      } else {
        // If not found, reset and return false
        this.addAccess = false;
        this.editAccess = false;
        this.viewAccess = false;
        this.deleteAccess = false;
        this.walletAccess = false;
        this.uploadAccess = false;
        return false;
      }
    }

  }

  ngOnInit(): void {
    this.setMinDateTime('');
    const today = new Date();
    const lastEnabledDate = new Date(today.setDate(today.getDate() - 6570));
    this.defaultDate = `${lastEnabledDate.getFullYear()}/${('0' + (lastEnabledDate.getMonth() + 1)).slice(-2)}`;
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    if (!this.currentUser) {
      this.router.navigate(['/']);
      return;
    }
    if (this.currentUser['module_access'] && this.currentUser['module_access'] != '') {
      if (JSON.parse(this.currentUser['module_access'])) {
        this.module_access = JSON.parse(this.currentUser['module_access'])
      } else {
        this.module_access = ''
      }
    } else {
      this.module_access = ''
    }
    var checkAccess = this.checkModuleAcces('1', '');
    if (!checkAccess) {
      alert("You don't have access for this module. Please contact admin.")
      this.router.navigate(['/Selectport']);
      return;
    }

    this.loginservice.getAllhow(this.currentUser).subscribe(
      data => {
        if (data['status'] == 'success') {
          if (data['data'].length > 0) {
            this.how_do = data['data'];
          } else {
            this.how_do = []
          }
        } else {
          this.how_do = []
        }
      }, error => { alert('Network Error how do know about this place API'); });




    this.loginservice.getAllCustomersList(this.currentUser).subscribe(
      data => {
        if (data['status'] == 'success') {
          if (data['data'].length > 0) {
            this.getAllCustomersList = data['data'];
          } else {
            this.getAllCustomersList = []
          }
        } else {
          this.getAllCustomersList = []
        }

        this.memLastId = data['memLastId'];
      }, error => { alert('Network Error getAllCustomersList API'); });

    this.loginservice.getemp('', this.currentUser).subscribe(
      data => {
        if (data['comp_details'].length > 0) {
          this.EMPS = data['comp_details'];
        } else {
          this.EMPS = [];
        }
      }, error => { alert('Network Error getemp API'); });

    this.loginservice.getserviceoffered('', '7', '', '', this.model, this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.memberships = data['comp_details'];
          } else {
            this.memberships = [];
          }
        }, error => { alert('Network Error getserviceoffered API'); });

    this.loginservice.getserviceoffered('', '8', '', '', this.model, this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.packages = data['comp_details'].map(p => ({
              ...p,
              checked: false // default unchecked
            }));
          } else {
            this.packages = [];
          }

        }, error => { alert('Network Error getserviceoffered API'); });


    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.date = new Date();
    this.initVar();
    if (this.loginservice.getLocalSession('customer_details')) {
      if (JSON.parse(this.loginservice.getLocalSession('customer_details'))) {
        this.model = JSON.parse(this.loginservice.getLocalSession('customer_details'));
        setTimeout(() => {
          this.setMemValues();
          const selected = this.model['packs'] || [];
          this.packages.forEach(pkg => {
            const match = selected.find(s => s.mem_id == pkg.service_category_id);
            if (match) {
              pkg.checked = true;
              // ⬅ merge all matched object's keys into pkg
              Object.assign(pkg, match);
            } else {
              pkg.checked = false;
            }
          });
        }, 2000);
        if (this.model.memStartDate != '' && this.model.memStartDate != null && this.model.memStartDate != '0000-00-00') {
          this.model.memStartDate1 = this.loginservice.Objtodate1(this.model.memStartDate)
          this.model.memStartDateOld = this.model.memStartDate;
        } else {
          this.model.memStartDate1 = '';
          this.model.memStartDateOld = '';
        }

        if (this.model.memEndDate != '' && this.model.memEndDate != null && this.model.memEndDate != '0000-00-00') {
          this.model.memEndDate1 = this.loginservice.Objtodate1(this.model.memEndDate)
          this.model.memEndDateOld = this.model.memEndDate;
        } else {
          this.model.memEndDate1 = '';
          this.model.memEndDateOld = '';
        }
        if (this.model['dob'] === '0000-00-00') {
          this.model['dob'] = '';
        }
        if (this.model['scheduled_date'] && this.model['scheduled_date'] !== '0000-00-00 00:00:00' && this.model['scheduled_date'] !== '' && this.model['scheduled_date'] !== null) {
          const dt = this.model['scheduled_date'].replace(' ', 'T').slice(0, 16); // "YYYY-MM-DDTHH:mm"
          this.model['scheduled_date'] = dt;
          // Also set minDateTime if needed
          this.setMinDateTime(dt);
        } else {
          // If no date, set minDateTime to now
          this.setMinDateTime();
        }
      }
    }
    this._arout.params.subscribe(p => {
      if (p.scheduler_id) {
        localStorage.removeItem('customer_details');
        this.scheduler_id = p.scheduler_id
        this.loginservice.empList(this.model, this.currentUser).subscribe(
          data => {
            if (data['comp_details'].length > 0) {
              this.emp_list = data['comp_details'];
              this.model = {
                employee_id: 0,
                customer_description: 0,
                state: '',
                mem_id: '',
                how: ''
              }
            } else {
              this.emp_list = [];
            }
          }, error => { alert('Network Error emplist API'); });

        this.loginservice.getservicecategory('', '1', this.currentUser).subscribe(
          data => {
            if (data['comp_details'].length > 0) {
              this.dataresult = data['comp_details'];
              this.model = {
                customer_description: 0,
                employee_id: 0,
              }
            } else {
              this.dataresult = [];
            }
          }, error => { alert('Network Error getservicecategory API'); });
      }
    }, error => { alert('Network Error params API'); });



  }

  setMinDateTime(dateStr?: string) {
    let now: Date;
    if (dateStr) {
      now = new Date(dateStr); // convert string to Date
    } else {
      now = new Date();
    }

    const year = now.getFullYear();
    const month = ('0' + (now.getMonth() + 1)).slice(-2);
    const day = ('0' + now.getDate()).slice(-2);
    const hours = ('0' + now.getHours()).slice(-2);
    const minutes = ('0' + now.getMinutes()).slice(-2);

    this.minDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    return this.minDateTime; // <-- important if you are assigning
  }

  isPastDate(): boolean {
    const date = this.model.scheduled_date;
    if (!date || date === '0000-00-00 00:00:00') return true;
    // Convert string to Date object
    const selected = new Date(date);
    const now = new Date();
    // Compare
    return selected < now;
  }

  search = (text$: Observable<string>) =>
    text$
      .debounceTime(300)
      .distinctUntilChanged()
      .do(() => this.searching = true)
      .switchMap(term =>
        this.loginservice.getemployeeterm(term, 'customer_profile', this.currentUser)
          .do(() => this.searchFailed = false)
          .catch(() => {
            this.searchFailed = true;
            return Observable.of([]);
          }))
      .do(() => this.searching = false)
      .merge(this.hideSearchingWhenUnsubscribed)
  formatter = (x: { f_name: string }) => '';

  asignModel(n) {
    this.show = false;

    if (typeof n === 'object') {
      this.alreadyMember = n.mem_person;
      this.model = n;

      this.setMemValues();
      const selected = this.model['packs'] || [];
      this.packages.forEach(pkg => {
        // if (selected.some(s => s.mem_id == pkg.service_category_id)) {
        //   pkg.checked = true;
        // } else {
        //   pkg.checked = false;
        // }
        // find matching selected item based on mem_id

        const match = selected.find(s => s.mem_id == pkg.service_category_id);
        if (match) {
          pkg.checked = true;
          // ⬅ merge all matched object's keys into pkg
          Object.assign(pkg, match);
        } else {
          pkg.checked = false;
        }
      });

      if (this.model.memStartDate != '' && this.model.memStartDate != null && this.model.memStartDate != '0000-00-00') {
        this.model.memStartDate1 = this.loginservice.Objtodate1(this.model.memStartDate)
        this.model.memStartDateOld = this.model.memStartDate;
      } else {
        this.model.memStartDate1 = '';
        this.model.memStartDateOld = '';
      }

      if (this.model.memEndDate != '' && this.model.memEndDate != null && this.model.memEndDate != '0000-00-00') {
        this.model.memEndDate1 = this.loginservice.Objtodate1(this.model.memEndDate)
        this.model.memEndDateOld = this.model.memEndDate;
      } else {
        this.model.memEndDate1 = '';
        this.model.memEndDateOld = '';
      }

      if (n['dob'] === '0000-00-00') {
        this.model['dob'] = '';
      }
      if (n['scheduled_date'] && n['scheduled_date'] !== '0000-00-00 00:00:00' && n['scheduled_date'] !== '' && n['scheduled_date'] !== null) {
        const dt = n['scheduled_date'].replace(' ', 'T').slice(0, 16); // "YYYY-MM-DDTHH:mm"
        this.model['scheduled_date'] = dt;

        // Also set minDateTime if needed
        this.setMinDateTime(dt);
      } else {
        // If no date, set minDateTime to now
        this.setMinDateTime();
      }
      this.loginservice.setLocalSession(this.model, 'customer_details');
      this.Emp_Id = n.id;
      // if (typeof this.app.interview_date !== 'object') {
      //   this.app.interview_date = this._common.strToDates(n.interview_date);
      // }      

    } else {
      // this.initVar();
    }
  }


  onDateChanged(type, event: IMyDateModel): void {
    // date selected
    if (type === 'month') {
      this.model['getmonth'] = event;

    } else {
      this.model['getyear'] = event;
    }
  }


  initVar() {
    this.show = false;
    // localStorage.removeItem('customer_details');
    this.appSug = { f_name: '' }
    this.model = {
      ...this.model,
      phone: '',
      cus_gst: '',
      gender: '',
      state: '',
      mem_id: '',
      how: '',
      mem_parent_id: '',
      // f_name: n,
      email: '',
      reffered_id: '',
      membership: '',
      resume_path: '',
      id: '',
      f_name: '',
      dob: '',
      paidAmount: '',
      balanceAmount: '',
      memStartDate: '',
      memStartDateOld: '',
      memEndDate: '',
      memEndDateOld: '',
      memEndDateYear: '',
      joining_date: '',
      address: '',
      city: '',
      zip: '',
      employee_id: 0,
      mem_person: '2',
      is_package: '2',
      person1name: '',
      person1phone: '',
      person1dob: '',
      person2name: '',
      person2phone: '',
      person2gender: '',
      person1gender: '',
      person2dob: '',
      person3name: '',
      person3phone: '',
      person3dob: '',
      customer_description: 0


    };
  }

  // captureAndSend() {
  //   const element = document.getElementById('divToPrint');
  //   if (element) {
  //     html2canvas(element, {
  //       allowTaint: true,
  //       useCORS: true,
  //       logging: true,
  //       backgroundColor: null, // transparent background
  //       scale: 2, // Higher scale for better resolution
  //     }).then(canvas => {
  //       // Convert canvas to JPEG base64 string
  //       this.model['base64Image'] = canvas.toDataURL('image/jpeg', 1.0);

  //       // Send the base64 image to the server

  //     }).catch(error => {
  //       console.error('Error capturing element with html2canvas', error);
  //     });
  //   } else {
  //     console.error('Element not found');
  //   }
  // }


  // savecus() {

  //   if (this.model['id'] === '' && this.model.mem_person == 1) {
  //     alert('nem mem per');
  //     this.captureAndSend();
  //   }

  //   this.showLoader = true;
  //   if ((this.model.mem_id == 0 || this.model.mem_id == '') && this.model.mem_person == 1) {
  //     this._flashMessagesService.show('Required field(s) is mandatory', { cssClass: 'alert-danger' });
  //     this.showLoader = false;
  //     this.showMemAlert = true;
  //     return false;
  //   }

  //   if (this.model.phone && this.model.phone.length < 10) {
  //     this._flashMessagesService.show('Phone is required', { cssClass: 'alert-danger' });
  //     this.showLoader = false;
  //     // this.showMemAlert = true;
  //     return false;
  //   }
  //   this.loginservice.savecus(this.model, this.currentUser, this.scheduler_id)
  //     .subscribe(
  //       data => {
  //         if (data['status'] === 'success') {
  //           this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
  //           this.showLoader = false;

  //           // if (this.targetfile) {
  //           //   this.uploadmanager(this.formdata, this.upname, this.Emp_Id)
  //           // } else {
  //           // }
  //           this.loginservice.setLocalSession(data['comp_details'][0], 'customer_details');
  //           this.model = data['comp_details'][0];
  //           this.setMemValues();

  //           if (this.model.memStartDate != '' && this.model.memStartDate != null && this.model.memStartDate != '0000-00-00') {
  //             this.model.memStartDate1 = this.loginservice.Objtodate1(this.model.memStartDate)
  //             this.model.memStartDateOld = this.model.memStartDate;
  //           } else {
  //             this.model.memStartDate1 = '';
  //             this.model.memStartDateOld = '';
  //           }

  //           if (this.model.memEndDate != '' && this.model.memEndDate != null && this.model.memEndDate != '0000-00-00') {
  //             this.model.memEndDate1 = this.loginservice.Objtodate1(this.model.memEndDate)
  //             this.model.memEndDateOld = this.model.memEndDate;
  //           } else {
  //             this.model.memEndDate1 = '';
  //             this.model.memEndDateOld = '';
  //           }

  //           if (data['comp_details'][0]['dob'] === '0000-00-00') {
  //             this.model['dob'] = '';
  //           }
  //           if (data['comp_details'][0]['person1dob'] === '0000-00-00') {
  //             this.model['person1dob'] = '';
  //           }
  //           if (data['comp_details'][0]['person2dob'] === '0000-00-00') {
  //             this.model['person2dob'] = '';
  //           }
  //           if (data['comp_details'][0]['memStartDate'] === '0000-00-00') {
  //             this.model['memStartDate'] = '';
  //           }
  //           if (data['comp_details'][0]['memEndDate'] === '0000-00-00') {
  //             this.model['memEndDate'] = '';
  //           }
  //           if (data['comp_details'][0]['memStartDate'] === '0000-00-00') {
  //             this.model['memStartDateOld'] = '';
  //           }
  //           if (data['comp_details'][0]['memEndDate'] === '0000-00-00') {
  //             this.model['memEndDateOld'] = '';
  //           }
  //           this.model['scheduled_date'] = new Date(data['comp_details'][0]['scheduled_date']);
  //           if (this.scheduler_id) {
  //             this.router.navigate(['/customer-scheduler-list']);
  //           }
  //         } else if (data['status'] === 'duplicate') {
  //           this._flashMessagesService.show(data['msg'], { cssClass: 'alert-danger' });
  //           this.showLoader = false;
  //         } else {
  //           this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
  //           this.showLoader = false;
  //         }
  //       },
  //       error => {
  //         alert('Error');
  //       });
  // }


  captureAndSend(): Promise<void> {
    return new Promise((resolve, reject) => {
      const element = document.getElementById('divToPrint');
      if (element) {
        html2canvas(element, {
          allowTaint: true,
          useCORS: true,
          logging: true,
          backgroundColor: null, // transparent background
          scale: 2, // Higher scale for better resolution
        }).then(canvas => {
          // Convert canvas to JPEG base64 string
          this.model['base64Image'] = canvas.toDataURL('image/jpeg', 1.0);

          // Resolve the promise once the image is captured
          resolve();
        }).catch(error => {
          console.error('Error capturing element with html2canvas', error);
          reject(error); // Reject the promise in case of error
        });
      } else {
        console.error('Element not found');
        reject('Element not found'); // Reject if the element is not found
      }
    });
  }

  onPackageChange(pack: any) {

    // When UNCHECKED
    if (!pack.checked) {
      this.removedPack.push(pack)
      // this.loginservice.removeSelectedPackage(this.model.id, pack.service_category_id)
      //   .subscribe(
      //     res => {
      //     },
      //     err => {
      //       console.error("Error removing package", err);
      //     }
      //   );
    } else {
      const index = this.removedPack.findIndex(
        p => p.service_category_id === pack.service_category_id
      );

      if (index !== -1) {
        this.removedPack.splice(index, 1);
      }
    }

  }

  async savecus() {
    if (this.model['mem_person'] === '1' && this.model['mem_id'] > 0 && Number(this.model.paidAmount) === 0) {
      alert('Membership amount is required');
      return false;
    }

    // let totPay = (Number(this.model.cash) || 0) + (Number(this.model.g_pay) || 0) + (Number(this.model.card) || 0) + (Number(this.model.cheque) || 0) + (Number(this.model.online_banking) || 0) + (Number(this.model.salary) || 0);
    // if (Number(this.model.paidAmount) !== Number(Number(totPay).toFixed(1))) {
    //   alert('Membership paying amount is not matching with the mode of payment value!');
    //   return false;
    // }
    if (this.model['id'] === '' && this.model.mem_person == 1) {
      try {
        if (this.currentUser.salon_id === '1') { await this.captureAndSend(); } // Wait for the capture to complete
      } catch (error) {
        console.error('Failed to capture membership card:', error);
        return false; // Stop execution if capture fails
      }
    }

    if (this.alreadyMember !== '1' && this.model['mem_person'] == '1') {
      try {
        if (this.currentUser.salon_id === '1') { await this.captureAndSend(); } // Wait for the capture to complete
      } catch (error) {
        console.error('Failed to capture membership card:', error);
        return false; // Stop execution if capture fails
      }
    }

    this.showLoader = true;

    if ((this.model.mem_id == 0 || this.model.mem_id == '') && this.model.mem_person == 1) {
      this._flashMessagesService.show('Required field(s) is mandatory', { cssClass: 'alert-danger' });
      this.showLoader = false;
      this.showMemAlert = true;
      return false;
    }

    if (this.model.phone && this.model.phone.length < 10) {
      this._flashMessagesService.show('Phone is required', { cssClass: 'alert-danger' });
      this.showLoader = false;
      return false;
    }


    // VALIDATION: If need package = yes but no package selected
    if (this.model.is_package === '1') {

      // Optional chaining not supported in Angular 5 — use old safe check
      const selected = (this.packages && this.packages.filter(p => p.checked)) || [];
      const removed = this.removedPack || [];

      if (selected.length === 0) {
        alert("Please select at least one package");
        this.showLoader = false;
        return false; // STOP SAVE
      }

      // collect selected packages into model
      this.model['removedPack'] = removed.map(p => ({
        id: p.id,
        service_category_id: p.service_category_id,
        service_list_id: p.service_list_id,
        memAmt: p.memAmt,
        start_date: p.start_date,
        end_date: p.end_date,
      }));

      this.model['selectedPackages'] = selected.map(p => ({
        id: p.id,
        service_category_id: p.service_category_id,
        service_list_id: p.service_list_id,
        memAmt: p.memAmt,
        start_date: p.start_date,
        end_date: p.end_date,
      }));

    } else {
      this.packages = this.packages.map(p => ({
        ...p,
        checked: false // default unchecked
      }));
      this.model['selectedPackages'] = []; // clear if No
      this.model['removedPack'] = []; // clear if No
    }



    this.loginservice.savecus(this.model, this.currentUser, this.scheduler_id)
      .subscribe(async data => {
        if (data['status'] === 'success') {
          this.showLoader = false;
          this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
          if (this.model['id'] === '' && this.model.mem_person == 1) {
            alert('New member detected. Preparing membership card...');
          }

          if (this.alreadyMember !== '1' && this.model['mem_person'] == '1') {
            alert('New member detected. Preparing membership card...');
          }


          this.loginservice.setLocalSession(data['comp_details'][0], 'customer_details');
          this.alreadyMember = data['comp_details'][0]['mem_person'];
          this.model = data['comp_details'][0];
          this.setMemValues();
          const selected = this.model['packs'] || [];

          this.packages.forEach(pkg => {
            // if (selected.some(s => s.mem_id == pkg.service_category_id)) {
            //   pkg.checked = true;
            // } else {
            //   pkg.checked = false;
            // }
            // find matching selected item based on mem_id
            const match = selected.find(s => s.mem_id == pkg.service_category_id);

            if (match) {
              pkg.checked = true;

              // ⬅ merge all matched object's keys into pkg
              Object.assign(pkg, match);

            } else {
              pkg.checked = false;
            }
          });

          // Handle membership start and end dates
          if (this.model.memStartDate != '' && this.model.memStartDate != null && this.model.memStartDate != '0000-00-00') {
            this.model.memStartDate1 = this.loginservice.Objtodate1(this.model.memStartDate);
            this.model.memStartDateOld = this.model.memStartDate;
          } else {
            this.model.memStartDate1 = '';
            this.model.memStartDateOld = '';
          }

          if (this.model.memEndDate != '' && this.model.memEndDate != null && this.model.memEndDate != '0000-00-00') {
            this.model.memEndDate1 = this.loginservice.Objtodate1(this.model.memEndDate);
            this.model.memEndDateOld = this.model.memEndDate;
          } else {
            this.model.memEndDate1 = '';
            this.model.memEndDateOld = '';
          }

          // Handle other dates and navigate if necessary
          if (data['scheduled_date'] && data['scheduled_date'] !== '0000-00-00 00:00:00' && data['scheduled_date'] !== '' && data['scheduled_date'] !== null) {
            const dt = data['scheduled_date'].replace(' ', 'T').slice(0, 16); // "YYYY-MM-DDTHH:mm"
            this.model['scheduled_date'] = dt;

            // Also set minDateTime if needed
            this.setMinDateTime(dt);
          } else {
            // If no date, set minDateTime to now
            this.setMinDateTime();
          }
          if (this.scheduler_id) {
            this.router.navigate(['/customer-scheduler-list']);
          }
        } else if (data['status'] === 'duplicate') {
          this.model['base64Image'] = '';
          this._flashMessagesService.show(data['msg'], { cssClass: 'alert-danger' });
          this.showLoader = false;
        } else {
          this.model['base64Image'] = '';
          this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
          this.showLoader = false;
        }
      },
        error => {
          alert('Network Error Save Customer');
        }
      );
  }



  deleteEmp(id) {
    if (confirm('Deleting of this Customer is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deletegridData(id, 'id', 'customer_profile', 'status').subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.ngOnInit();
        },
          error => {
            alert('Error in delete');
            this.showLoader = false;
          });
      }
    }

  }

  movePreviousNext(modelVal, n) {
    this.show = false;
    this.showLoader = true;
    this.loginservice.movePreviousNextemp(modelVal, n, 'customer_profile', this.currentUser)
      .subscribe(
        data => {
          if (data['status'] == 'success') {
            this.alreadyMember = data['comp_details'][0]['mem_person'];
            this.model = data['comp_details'][0];
            // alert(this.model.mem_id)
            // alert(this.model.mem_person)
            this.setMemValues();
            const selected = this.model['packs'] || [];
            this.packages.forEach(pkg => {
              // if (selected.some(s => s.mem_id == pkg.service_category_id)) {
              //   pkg.checked = true;
              // } else {
              //   pkg.checked = false;
              // }
              // find matching selected item based on mem_id
              const match = selected.find(s => s.mem_id == pkg.service_category_id);

              if (match) {
                pkg.checked = true;

                // ⬅ merge all matched object's keys into pkg
                Object.assign(pkg, match);

              } else {
                pkg.checked = false;
              }
            });



            if (this.model.memStartDate != '' && this.model.memStartDate != null && this.model.memStartDate != '0000-00-00') {
              this.model.memStartDate1 = this.loginservice.Objtodate1(this.model.memStartDate)
              this.model.memStartDateOld = this.model.memStartDate;
            } else {
              this.model.memStartDate1 = '';
              this.model.memStartDateOld = '';
            }

            if (this.model.memEndDate != '' && this.model.memEndDate != null && this.model.memEndDate != '0000-00-00') {
              this.model.memEndDate1 = this.loginservice.Objtodate1(this.model.memEndDate)
              this.model.memEndDateOld = this.model.memEndDate;
            } else {
              this.model.memEndDate1 = '';
              this.model.memEndDateOld = '';
            }


            if (data['comp_details'][0]['dob'] === '0000-00-00') {
              this.model['dob'] = '';
            }
            if (data['comp_details'][0]['scheduled_date'] && data['comp_details'][0]['scheduled_date'] !== '0000-00-00 00:00:00' && data['comp_details'][0]['scheduled_date'] !== '' && data['comp_details'][0]['scheduled_date'] !== null) {
              const dt = data['comp_details'][0]['scheduled_date'].replace(' ', 'T').slice(0, 16); // "YYYY-MM-DDTHH:mm"
              this.model['scheduled_date'] = dt;

              // Also set minDateTime if needed
              this.setMinDateTime(dt);
            } else {
              // If no date, set minDateTime to now
              this.setMinDateTime();
            }
            this.Emp_Id = this.model.id;
            this.loginservice.setLocalSession(data['comp_details'][0], 'customer_details');
          } else {
            this._flashMessagesService.show('No record found!', { cssClass: 'alert-danger' });
          }
          this.showLoader = false;
        },
        error => {
          this._flashMessagesService.show('No record found!', { cssClass: 'alert-danger' });
          this.showLoader = false;
        });

  }


  CheckPhone(value, name) {
    // Regular expression to check for pure integers
    const pureIntegerRegex = /^[0-9]+$/;

    // Regular expression to check for pure strings (alphabets only)
    const pureStringRegex = /^[a-zA-Z]+$/;

    // Check if the value is a pure integer
    if (pureIntegerRegex.test(value)) {

    }
    // Check if the value is a pure string
    else if (pureStringRegex.test(value)) {
      this.model[name] = '';
      this._flashMessagesService.show('Invalid Number', { cssClass: 'alert-danger' });
      // alert('Invalid Number');
    }
    // Check if the value is a mix of both integer and string
    else if (/^[a-zA-Z0-9]+$/.test(value)) {
      this.model[name] = '';
      this._flashMessagesService.show('Invalid Number', { cssClass: 'alert-danger' });
      // alert('Invalid Number');
    }
    // If none of the above, then it contains special characters
    else {
      this.model[name] = '';
      this._flashMessagesService.show('Invalid Number', { cssClass: 'alert-danger' });
      // alert('Invalid Number');
    }
  }


  async seprateMembership(f) {

    alert('New member detected. Preparing separate membership card...');

    try {
      if (this.currentUser.salon_id === '1') { await this.captureAndSend(); } // Wait for the capture to complete
    } catch (error) {
      console.error('Failed to capture membership card:', error);
      return; // Stop execution if capture fails
    }

    if (this.model.anniversary == '' || this.model.anniversary == '0000-00-00') {
      f.submitted = true;
      // return false;
    }

    if (this.model.payment_status == '' || this.model.payment_status == '0' || this.model.payment_status == 0) {

      f.submitted = true;
      return false;
    }

    if (this.model.paidAmount <= 0) {
      f.submitted = true;
      return false;
    }

    if (this.model.memStartDate == '' || this.model.memStartDate == '0000-00-00') {
      f.submitted = true;
      return false;
    }
    if (this.model.memEndDateYear == '' || this.model.memEndDateYear == '0000-00-00') {
      f.submitted = true;
      return false;
    }

    if (this.model.mem_id <= 0) {
      f.submitted = true;
      return false;
    }

    if (confirm("Are Sure! Need New Mebership! This Can't Be Undone")) {
      this.loginservice.seprateMembership(this.model, this.currentUser)
        .subscribe(
          data => {
            if (data['status'] === 'success') {
              this.show = false;
              this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
              this.showLoader = false;

              // if (this.targetfile) {
              //   this.uploadmanager(this.formdata, this.upname, this.Emp_Id)
              // } else {
              // }
              this.loginservice.setLocalSession(data['comp_details'][0], 'customer_details');
              this.alreadyMember = data['comp_details'][0]['mem_person'];
              this.model = data['comp_details'][0];


              if (this.model.memStartDate != '' && this.model.memStartDate != null && this.model.memStartDate != '0000-00-00') {
                this.model.memStartDate1 = this.loginservice.Objtodate1(this.model.memStartDate)
                this.model.memStartDateOld = this.model.memStartDate;
              } else {
                this.model.memStartDate1 = '';
                this.model.memStartDateOld = '';
              }

              if (this.model.memEndDate != '' && this.model.memEndDate != null && this.model.memEndDate != '0000-00-00') {
                this.model.memEndDate1 = this.loginservice.Objtodate1(this.model.memEndDate)
                this.model.memEndDateOld = this.model.memEndDate;
              } else {
                this.model.memEndDate1 = '';
                this.model.memEndDateOld = '';
              }

              if (data['comp_details'][0]['dob'] === '0000-00-00') {
                this.model['dob'] = '';
              }
              if (data['comp_details'][0]['person1dob'] === '0000-00-00') {
                this.model['person1dob'] = '';
              }
              if (data['comp_details'][0]['person2dob'] === '0000-00-00') {
                this.model['person2dob'] = '';
              }
              if (data['comp_details'][0]['memStartDate'] === '0000-00-00') {
                this.model['memStartDate'] = '';
              }
              if (data['comp_details'][0]['memEndDate'] === '0000-00-00') {
                this.model['memEndDate'] = '';
              }

              if (data['comp_details'][0]['memStartDate'] === '0000-00-00') {
                this.model['memStartDateOld'] = '';
              }
              if (data['comp_details'][0]['memEndDate'] === '0000-00-00') {
                this.model['memEndDateOld'] = '';
              }
              if (data['comp_details'][0]['scheduled_date'] && data['comp_details'][0]['scheduled_date'] !== '0000-00-00 00:00:00' && data['comp_details'][0]['scheduled_date'] !== '' && data['comp_details'][0]['scheduled_date'] !== null) {
                const dt = data['comp_details'][0]['scheduled_date'].replace(' ', 'T').slice(0, 16); // "YYYY-MM-DDTHH:mm"
                this.model['scheduled_date'] = dt;

                // Also set minDateTime if needed
                this.setMinDateTime(dt);
              } else {
                // If no date, set minDateTime to now
                this.setMinDateTime();
              }
              if (this.scheduler_id) {
                this.router.navigate(['/customer-scheduler-list']);
              }
            } else if (data['status'] === 'duplicate') {
              this._flashMessagesService.show(data['msg'], { cssClass: 'alert-danger' });
              this.showLoader = false;
            } else {
              this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
              this.showLoader = false;
            }
          },
          error => {
            alert('Network Error Seprate Membership');
          });
    }
  }

  checkMem(event: Event) {
    if (this.model.showMemButton) {
      this.show = false;
      this.model.memEndDate = this.model.memEndDateOld;
      this.model.memStartDate = this.model.memStartDateOld;

      this.model.person1name = '';
      this.model.person1phone = '';
      this.model.person1dob = '';

      this.model.person2name = '';
      this.model.person2phone = '';
      this.model.person2dob = '';

    } else {
      this.show = true;
      this.model.memEndDate = '';
      this.model.memStartDate = '';

      this.model.person1name = '';
      this.model.person1phone = '';
      this.model.person1dob = '';

      this.model.person2name = '';
      this.model.person2phone = '';
      this.model.person2dob = '';
    }
    // alert(this.model.memStartDate)
    // alert(this.model.memEndDate)
  }

  veiwMemBill() {

    this.router.navigate(['viewMemBill'], {
      queryParams: {
        model: JSON.stringify(this.model),
        customer_id: this.model.id
      }
    });
  }

  veiwPackBill(pack) {
    this.router.navigate(['veiwPackBill'], {
      queryParams: {
        model: JSON.stringify(this.model),
        pack: JSON.stringify(pack),
        customer_id: this.model.id
      }
    });
  }

  setMemValues() {
    let memship = '';
    if (this.model['mem_id'] > 0) {
      memship = this.memberships.filter(mem => mem.service_category_id === this.model['mem_id']);
      this.model['MemShip1'] = memship['0']['service_category'] + ' Card';
    } else {
      memship = '';
      this.model['MemShip1'] = 'Member Card';
    }
    this.model['MemShip'] = memship

  }

  // getenddatefromselecteddate(startDate: any, durationInYears: number): string {
  //   if (!startDate || !durationInYears) {
  //     alert('ssssss')
  //     return ''; // Return empty if the required values are not available
  //   }

  //   // Ensure `startDate` is a valid Date
  //   const start = startDate.jsdate
  //     ? new Date(startDate.jsdate)
  //     : new Date(startDate);

  //   if (isNaN(start.getTime())) {
  //     return ''; // Return empty if the date is invalid
  //   }

  //   const end = new Date(start);

  //   // Add the selected number of years to the start date
  //   end.setFullYear(start.getFullYear() + Number(durationInYears));

  //   // Format the end date as needed (e.g., dd-MM-yyyy)
  //   const formattedDate = `${end.getDate().toString().padStart(2, '0')}-${(end.getMonth() + 1)
  //     .toString()
  //     .padStart(2, '0')}-${end.getFullYear()}`;

  //   return formattedDate;
  // }

  getenddatefromselecteddate(startDate: any, durationInYears: number): string {
    if (!startDate || !durationInYears) {
      return '';
    }

    let start: Date;

    // Handle custom date object format
    if (startDate.year && startDate.month && startDate.day) {
      start = new Date(
        parseInt(startDate.year),
        parseInt(startDate.month) - 1, // Month is 0-indexed in JS Date
        parseInt(startDate.day)
      );
    } else if (startDate.jsdate) {
      start = new Date(startDate.jsdate);
    } else {
      start = new Date(startDate);
    }

    if (isNaN(start.getTime())) {
      return '';
    }

    const end = new Date(start);
    end.setFullYear(start.getFullYear() + Number(durationInYears));

    const formattedDate = `${end.getDate().toString().padStart(2, '0')}-${(end.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${end.getFullYear()}`;

    return formattedDate;
  }


  setPaidAmount() {
    this.model['paidAmount'] = '';
    this.model['balanceAmount'] = '';
    if (this.model['payment_status'] === '1') {
      this.model['paidAmount'] = this.model['MemShip']['0']['memAmt'];
      this.model['balanceAmount'] = this.model['MemShip']['0']['memAmt'] - this.model['paidAmount'];
    } else if (this.model['payment_status'] === '2') {
      // this.model['paidAmount'] = this.model['MemShip']['0']['memAmt'];
      this.model['balanceAmount'] = this.model['MemShip']['0']['memAmt'] - this.model['paidAmount'];
    }
  }

  balAmt() {
    if (this.model['paidAmount'] > 0) {
      this.model['balanceAmount'] = this.model['MemShip']['0']['memAmt'] - this.model['paidAmount'];
    } else {
      this.model['balanceAmount'] = this.model['MemShip']['0']['memAmt'];
    }
  }

  onPaymentMethodChange(paymentType: string) {
    const paymentMappings = {
      'mopcash': 'cash',
      'mopg_pay': 'g_pay',
      'mopcard': 'card',
      'mopcheque': 'cheque',
      'moponline_banking': 'online_banking',
      'mopsalary': 'salary',
    };

    const fieldName = paymentMappings[paymentType];

    if (this.model[paymentType] === true) {
      this.model[fieldName] = 0;
    } else {
      this.model[fieldName] = 0;
    }
  }

  checkExist(pack: any, model: any): boolean {
    if (!model || !model.packs || model.packs.length === 0) {
      return false;
    }
    return model.packs.some(p => p.mem_id == pack.service_category_id);
  }

  openUploadModal() {
    this.showUploadModal = true;
  }

  closeUploadModal() {
    this.showUploadModal = false;
    this.uploadErrors = [];
    this.selectedFile = null;
  }

  // async downloadSample() {
  //   const XLSX = await import('xlsx');
  //   const wb = XLSX.utils.book_new();

  //   // Sheet 1: Customer Data Template
  //   const customerData = [
  //     ['Customer Name', 'Phone', 'How do You Know about this Place?'],
  //     ['', '', ''] // Empty row for data entry
  //   ];
  //   const ws1 = XLSX.utils.aoa_to_sheet(customerData);
  //   XLSX.utils.book_append_sheet(wb, ws1, 'customer_data');

  //   // Sheet 2: Reference Options
  //   const referenceOptions = [
  //     ['Reference Options For How do You Know about this Place?'],
  //     ['Banner'],
  //     ['Direct Walk In'],
  //     ['EGB Staff'],
  //     ['Facebook'],
  //     ['Google'],
  //     ['Instagram'],
  //     ['Missed To Ask'],
  //     ['Other'],
  //     ['Our Customer'],
  //     ['Our Staff'],
  //     ['Pamphlet'],
  //     ['Referred By Another Person']
  //   ];
  //   const ws2 = XLSX.utils.aoa_to_sheet(referenceOptions);
  //   XLSX.utils.book_append_sheet(wb, ws2, 'reference_options');

  //   XLSX.writeFile(wb, 'customer_template.xlsx');
  // }

  downloadSample() {
    const wb = XLSX.utils.book_new();

    const customerData = [
      ['Customer Name', 'Phone', 'How do You Know about this Place?'],
      ['', '', '']
    ];
    const ws1 = XLSX.utils.aoa_to_sheet(customerData);
    XLSX.utils.book_append_sheet(wb, ws1, 'customer_data');

    const referenceOptions = [
      ['Reference Options For How do You Know about this Place?'],
      ['Banner'],
      ['Direct Walk In'],
      ['EGB Staff'],
      ['Facebook'],
      ['Google'],
      ['Instagram'],
      ['Missed To Ask'],
      ['Other'],
      ['Our Customer'],
      ['Our Staff'],
      ['Pamphlet'],
      ['Referred By Another Person']
    ];
    const ws2 = XLSX.utils.aoa_to_sheet(referenceOptions);
    XLSX.utils.book_append_sheet(wb, ws2, 'reference_options');

    XLSX.writeFile(wb, 'customer_template.xlsx');
  }


  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
  }

  uploadExcel() {
    if (!this.selectedFile) return;

    this.showLoader = true;
    const formData = new FormData();
    formData.append('file', this.selectedFile);

    this.loginservice.uploadBulkCustomers(formData, this.currentUser).subscribe(
      data => {
        if (data['status'] === 'success') {
          this._flashMessagesService.show(`Successfully uploaded ${data['count']} customers`, { cssClass: 'alert-success' });
          this.closeUploadModal();
        } else if (data['status'] === 'error') {
          this.uploadErrors = data['message'];
          // alert(data['message'] || 'Upload failed');
          // this._flashMessagesService.show(data['message'] || 'Upload failed', { cssClass: 'alert-danger' });
        } else {
          this._flashMessagesService.show('Upload failed', { cssClass: 'alert-danger' });
        }
        this.showLoader = false;
      },
      error => {
        this._flashMessagesService.show('Error uploading file', { cssClass: 'alert-danger' });
        this.showLoader = false;
      }
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/customer-details/customer-details.component.ts